import { ALERT } from '../model/msg/equip';
import { getEquipsTpl, getSearchEquipLayerTpl } from './../model/tpl/equip';
import { isDefined, isString, isObject, not, truthy, falsy, notSingleEle, each, parseInt10, allOf, anyOf, getResolution, isPhoneResolution, getClassName } from '../../../utils/util';
import { handleApiError } from '../../../utils/service';
import { BREAKPOINTS, API_DOMAIN_DEFAULT } from '../../../model/model';
import TopBar from './TopBar';
import EquipCharacter from './EquipCharacter';
import EquipSetting from './EquipSetting';
import TotalStat from './TotalStat';
import SearchEquipLayer from './searchEquipLayer/SearchEquipLayer';
import EquipModel from './EquipModel';
import SingletonLoading from './../utils/SingletonLoading';
import SingletonGlobalEvents from '../../../utils/SingletonGlobalEvents';
import { getStatNoEquips, getStatReflectEquips, getSavedUserEquips, saveNewEquip, saveExistingEquip, deleteSavedEquip, getOrgStats } from '../utils/service';

class EquipSimulator {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) throw new Error('EquipSimulator constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      data: null,
      breakpoint: BREAKPOINTS,
      global: window
    }, options);

    console.log('EquipSimulator.js - _.option :', _.option);

    // data
    /*
     {
     page, // 'default', 'view', 'modify'
     statType, // 'my' or 'setting'
     serverId,
     serverName,
     classId,
     characterName,
     level,
     hp,
     mp,
     noEquipStats, // {mainStat:{itemAffectedStat, mainStat}, subStat, formattedSubStat}
     stats, // {mainStat:{itemAffectedStat, mainStat}, subStat, formattedSubStat}
     expandSlots, // {isEarringSlot, isInsigniaSlot, isLeftRingSlot, isRightRingSlot, isShoulderSlot}
     equipItems, // [{enchant, itemId, itemName, slot}
     isEditable, // true, false
     memo: '',
     idx: ''

     estimateStr // use only qna board view/edit page
     }
     */
    _.data = _.option.data;

    _.globalEvents = SingletonGlobalEvents.getInstance();

    _.model = EquipModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.topBar = null;
    _.equipCharacter = null;
    _.equipSetting = null;
    _.totalStat = null;
    _.searchEquipLayer = null;

    _.proxy = {
      resizeEventHandler: $.proxy(_.resizeEventHandler, _)
    };

    _.global = _.option.global;

    _.orgStats = null;


  }

  init() {
    const _ = this;

    console.log('EquipSimulator init()');

    _.destroy();

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('wrap must be single element.');

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    const equipTplFunc = doT.template(getEquipsTpl());
    _.wrap.empty().append(equipTplFunc(_.data));

    _.setTopBar();
    _.setEquipCharacter();
    _.setEquipSetting();
    _.setTotalStat();
    _.setSearchEquipLayer();

    _.equipSetting.setData({
      expandSlots: _.data.expandSlots,
      itemList: _.data.equipItems
    });

    console.log('EquipSimulator setInstance - _.data :', _.data);

    // for display difference of stats
    if (allOf(isDefined(_.data.noEquipStats), isDefined(_.data.stats))) {
      _.totalStat.setChangedStats(_.data.stats);
    }

    // for diff, save current status
    _.equipSetting.saveCurrentAllStatus();
    _.totalStat.saveCurrentAllStatus();

    // at the beginning, set diff to equipSetting, totalStat
    _.setDiffByCompareSavedStatus();

    // global events
    _.globalEvents.addCallback('resize', _.proxy.resizeEventHandler);
  }

  setTopBar() {
    const _ = this;

    _.topBar = new TopBar({
      page: _.data.page,
      wrap: $('header', _.wrap)
    }).init();

    _.setTopBarEvents(true);
  }

  setEquipCharacter() {
    const _ = this;

    _.equipCharacter = new EquipCharacter({
      wrap: $('.char', _.wrap),
      data: _.data
    }).init();

    $(_.equipCharacter).on(EquipCharacter.EVT_SHOW_TOTAL_STAT, function (evt) {
      _.equipSetting.showEquipSetting(false);
      _.totalStat.showTotalStat(true);

      _.setBodyOverflowHidden(true);
    });
  }

  setEquipSetting() {
    const _ = this;

    // _.orgStats = getOrgStats();
    // console.log('EquipSimulator.js > setEquipSetting() getOrgStats() ## orgStats ', _.orgStats ); // 201908

    _.equipSetting = new EquipSetting({
      wrap: $('.variation', _.wrap),
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      data: _.data
    }).init();

    if (anyOf(_.data.page === 'default', _.data.page === 'modify')) {
      // default, modify page

      $(_.equipSetting).on(EquipSetting.RESET_ONE_LIST, function (evt) {
        console.log('RESET_ONE_LIST');

        if (truthy(_.loading.isLoading)) return;

        const wearEquips = evt.wearEquips.slice();
        console.log('wearEquips :', wearEquips);

        if (wearEquips.length > 0) {
          // wear equips
          console.log('EquipSetting.RESET_ONE_LIST - wear equips');

          let sendItemList = [];
          each(wearEquips, (item) => sendItemList.push({
            itemId: item.itemId,
            itemName: item.itemName,
            enchant: item.enchant,
            slot: item.slot
          }));


          console.log('EquipSimulator.js > setEquipSetting() getStatReflectEquips - sendData :', _.data);


          getStatReflectEquips({ // simulator/equip/{class}/{itemId}/item
            apiDomain: _.option.apiDomain,
            searchApiDomain: _.option.searchApiDomain,
            sendData: {
              classId: _.data.classId,
              level: _.data.level,
              hp:  _.data.hp, // 201908
              mp: _.data.mp, // 201908
              currentStat: _.totalStat.getBaseMainStats(),
              itemList: sendItemList
            },
            beforeSend: () => _.loading.start()

          }).then(function (data, textStatus, jqXHR) {
            console.log('getStatReflectEquips - data :', data);

            _.loading.end();

            _.equipSetting.resetOneList(evt.list, evt.itemObj);
            _.totalStat.setChangedStats(data); // {mainStat: {mainStat, itemAffectedStat}, subStat, formattedSubStat}

            _.setDiffByCompareSavedStatus();

          }).catch(function (err) {
            console.log('getStatReflectEquips - error :', err);

            _.loading.end();

            if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_STATS_REFLECT_EQUIP_ITEMS); // '현재 장비 착용 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
          });

        } else {
          // wear no equips
          console.log('EquipSetting.RESET_ONE_LIST - wear no equips');

          getStatNoEquips({
              apiDomain: _.option.apiDomain,
              searchApiDomain: _.option.searchApiDomain,
              sendData: {
                classId: _.data.classId,
                level: _.data.level,
                hp: _.data.hp,
                mp: _.data.mp,
                currentStat: _.totalStat.getBaseMainStats()
              },
              beforeSend: () => _.loading.start()

            }).then(function (data, textStatus, jqXHR) {
              console.log('getStatNoEquips - data :', data);

            _.loading.end();

            _.equipSetting.resetOneList(evt.list, evt.itemObj);
            _.totalStat.setChangedStats(data);

            _.setDiffByCompareSavedStatus();

          }).catch(function (err) {
            console.log('getStatNoEquips - error :', err);

            _.loading.end();

            if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
          });
        }
      });

    } else {
      // view page
    }

    $(_.equipSetting).on(EquipSetting.SHOW_ITEM_SEARCH_LAYER, function (evt) {
      console.log('evt.slotName :', evt.slotName);
      console.log('getClassName(_.data.classId) :', getClassName(_.data.classId));
      console.log('evt.slotId :', evt.slotId);
      console.log('_.data.serverId :', _.data.serverId);

      _.searchEquipLayer.setSearchData({
        fex1: evt.slotName,
        fex2: getClassName(_.data.classId),
        slotId: evt.slotId,
        serverId: _.data.serverId
      });

      _.searchEquipLayer.show(true);
      _.searchEquipLayer.focusSearchInput();
    });

    $(_.equipSetting).on(EquipSetting.DISPLAY_AFFECT_STATS, function (evt) {
      _.totalStat.displayAffectStats(evt.stats);
    });
  }

  setTotalStat() {
    const _ = this;

    console.log('EquipSimulator.js > new TotalStat _.data: ' , _.data );
    _.totalStat = new TotalStat({
      wrap: $('.variation', _.wrap),
      data: {
        hp: _.data.hp,
        mp: _.data.mp,
        noEquipStats: _.data.noEquipStats,
        stats: _.data.stats
      }
    }).init();

    $(_.totalStat).on(TotalStat.EVT_CLOSE, function (evt) {
      _.equipSetting.showEquipSetting(true);
      _.totalStat.showTotalStat(false);

      _.setBodyOverflowHidden(false);
    });
  }

  setSearchEquipLayer() {
    const _ = this;

    $('.simulator__equip', _.wrap).append(getSearchEquipLayerTpl());

    _.searchEquipLayer = new SearchEquipLayer({
      wrap: $('.layer-item-search', _.wrap),
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
    }).init();

    _.searchEquipLayer.show(false);

    $(_.searchEquipLayer).on(SearchEquipLayer.EVT_SELECT_EQUIP, function (evt) {
      _.searchEquipLayer.show(false);

      _.changeEquip(evt.obj); // {itemId, enchant, price, itemName, slot, style, type, cashItem(isCashItem), eventItem(isEventItem), itemImageUrl} // 2022.01
    });

    $(_.searchEquipLayer).on(SearchEquipLayer.EVT_CLOSE, function (evt) {
      _.searchEquipLayer.show(false);
    });
  }

  setBodyOverflowHidden(flag) {
    const val = (truthy(flag)) ? 'hidden' : '';
    $('body').css({overflow: val});
  }

  resizeEventHandler(evt) {
    const _ = this,
      resolution = getResolution(_.option.breakpoint, _.global);

    if (falsy(isPhoneResolution(resolution))) {
      _.setBodyOverflowHidden(false);

      _.totalStat.resetShowTotalStat();

      // not phone
      if (falsy(_.equipSetting.isShowEquipSetting())) {
        _.equipSetting.showEquipSetting(true);
      }
    }
  }

  setDiffByCompareSavedStatus() {
    const _ = this;

    // reset diff
    _.equipSetting.resetDiffAtAllEquips(); // remove '.diff' class
    _.totalStat.resetDiffAtAllStats(); // remove '.diff' class

    // set compared diff
    _.equipSetting.setDiffByCompareSavedEquipsAndNewEquips();
    _.totalStat.setDiffByCompareSavedFormattedStatAndNewStats();
  }

  changeEquip(equipItem = {
    itemId: '',
    enchant: 0,
    price: 0,
    itemName: '',
    slot: '',
    style: '',
    cashItem: false, // 2022.01
    eventItem: false // 2022.01
    // isCashItem: false,
    // isEventItem: false
  }) {
    const _ = this;

    const resultAfterTryWearItem = _.equipSetting.wearItemAndGetResult(equipItem, true);
    console.log('EquipSimulator.js changeEquip() resultAfterTryWearItem :', resultAfterTryWearItem);

    if (truthy(resultAfterTryWearItem.result)) {
      // console.log('changeEquip() - can wear item');

      if (truthy(_.loading.isLoading)) return;

      const equipItems = _.equipSetting.getEquips().wearEquips.slice();

      let itemList = [];
      each(equipItems, (item) => {
        if (item.slot !== equipItem.slot) itemList.push(item);
      });
      itemList.push(equipItem);

      let sendItemList = [];
      each(itemList, (item) => {
        sendItemList.push({itemId: item.itemId, itemName: item.itemName, enchant: item.enchant, slot: item.slot});
      });

      console.log('EquipSimulator.js > changeEquip() equipItem :' , equipItem);
      console.log('EquipSimulator.js > changeEquip() sendItemList :', sendItemList, ' / _.data : ',  _.data );


      _.orgStats = getOrgStats();
      console.log('EquipSimulator.js > changeEquip() getOrgStats() ## orgStats ', _.orgStats ); // 201908


      getStatReflectEquips({
        apiDomain: _.option.apiDomain,
        searchApiDomain: _.option.searchApiDomain,
        sendData: {
          classId: _.data.classId,
          level: _.data.level,
          hp:  _.orgStats.hp, // 201908
          mp: _.orgStats.mp, // 201908
          currentStat: _.totalStat.getBaseMainStats(),
          itemList: sendItemList
        },
        beforeSend: () => _.loading.start()

      }).then(function (data, textStatus, jqXHR) {
        console.log('getStatReflectEquips - data :', data);

        _.loading.end();

        _.equipSetting.wearItemAndGetResult(equipItem);
        _.equipSetting.updateEquipsBtnInfoAndBtnReset();

        _.totalStat.setChangedStats(data); // {mainStat: {mainStat, itemAffectedStat}, subStat, formattedSubStat}

        _.setDiffByCompareSavedStatus();

      }).catch(function (err) {
        console.log('getStatReflectEquips - error :', err);

        _.loading.end();

        if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_STATS_REFLECT_EQUIP_ITEMS); // '현재 장비 착용 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });

    } else {
      console.log('changeEquip() - can not wear item');

      if (allOf(isDefined(resultAfterTryWearItem.msg), resultAfterTryWearItem.msg !== '')) {
        _.global.alert(resultAfterTryWearItem.msg);
      }
    }
  }

  setTopBarEvents(flag) {
    const _ = this,
      $topBar = $(_.topBar);

    if ($topBar.length <= 0) return;

    if (truthy(flag)) {
      $topBar.on(TopBar.EVT_CLOSE, function (evt) {
        $(_).trigger({type: EquipSimulator.EVT_CLOSE});
      });

      $topBar.on(TopBar.EVT_SAVE, function (evt) {
        console.log('save :', _.option);

        if (truthy(_.loading.isLoading)) return;

        // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/equip/user
        getSavedUserEquips({
          apiDomain: _.option.apiDomain,
          searchApiDomain: _.option.searchApiDomain,
          beforeSend: () => _.loading.start()

        }).then(function (data, textStatus, jqXHR) {
          console.log('getSavedUserEquips - data :', data);

          _.loading.end();

          if (truthy(Array.isArray(data))) {
            const savedUserStatNum = data.length;

            if (allOf(_.data.page === 'default', savedUserStatNum >= _.model.USER_EQUIP_NUM_LIMIT)) {
              _.global.alert(ALERT.SAVE_EQUIP_LIMIT_SIMPLE); // '장비 세팅 저장은 계정당 최대 6개까지 가능합니다.'

              return;
            }

            // case - 'default', 'modify' page
            let itemList = [];
            each(_.equipSetting.getEquips().wearEquips, function (equip) {
              itemList.push({
                itemId: equip.itemId,
                itemName: equip.itemName,
                enchant: equip.enchant,
                slot: equip.slot
              });
            });


            _.orgStats = getOrgStats();
            console.log('EquipSimulator.js > setTopBarEvents saveEquipSetting _.orgStats : ', _.orgStats ); //  201908

            _.saveEquipSetting({
              "serverId": parseInt10(_.data.serverId),
              "characterName": _.data.characterName,
              "classId": parseInt10(_.data.classId),
              "level": parseInt10(_.data.level),
              "baseStatType": _.data.statType,
              "hp": _.orgStats.hp, // 201908 _.data.hp,
              "mp": _.orgStats.mp, // 201908 _.data.mp,
              "mainStat": _.totalStat.getBaseMainStats(), // {STR, DEX, INT, CON, WIS, CHA}
              "itemList": itemList,
              "memo": _.equipCharacter.getTitle()
            });

          } else {
            _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
          }

        }).catch(function (err) {
          console.log('getSavedUserEquips - error :', err);

          _.loading.end();

          if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        });
      });

      $topBar.on(TopBar.EVT_TRY_RESET, function (evt) {
        // no use
      });

      $topBar.on(TopBar.EVT_RESET, function (evt) {
        console.log('TopBar.EVT_RESET');

        _.restoreAllEquipsAndTotalStat();
      });

      $topBar.on(TopBar.EVT_MODIFY, function (evt) {
        console.log('TopBar.EVT_MODIFY');

        _.switchMode(_.data.page, 'modify');
      });

      $topBar.on(TopBar.EVT_DELETE, function (evt) {
        if (allOf(isDefined(_.data.idx), _.data.idx !== '')) {
          const msg = ALERT.TRY_DELETE_EQUIP({memo: _.data.memo});

          const isConfirmDelete = _.global.confirm(msg); // ${data.memo} 장비 세팅을 삭제하시겠습니까?
          if (isConfirmDelete) _.deleteEquipSetting(_.data.idx);
        }
      });

    } else {
      $topBar
        .off(TopBar.EVT_CLOSE)
        .off(TopBar.EVT_SAVE)
        .off(TopBar.EVT_TRY_RESET)
        .off(TopBar.EVT_RESET)
        .off(TopBar.EVT_MODIFY)
        .off(TopBar.EVT_DELETE);
    }
  }

  switchMode(prevPage, nextPage) {
    const _ = this;

    if (allOf(prevPage === 'view', nextPage === 'modify')) {
      _.data.page = 'modify';

      _.init();
    }
  }

  saveEquipSetting(data) {
    const _ = this;

    switch (_.data.page) {
      case 'default':
        saveNewEquip({
          apiDomain: _.option.apiDomain,
          searchApiDomain: _.option.searchApiDomain,
          sendData: data,
          beforeSend: () => _.loading.start()

        }).then(function (data, textStatus, jqXHR) {
          console.log('saveNewEquip - data :', data);

          _.loading.end();

          if (allOf(isObject(data), data.result === 'success')) {
            $(_).trigger({type: EquipSimulator.EVT_SAVE_EQUIP});

          } else {
            _.global.alert(ALERT.FAIL_SAVE_EQUIP); // '현재 장비 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
          }

        }).catch(function (err) {
          console.log('saveNewEquip - error :', err);

          _.loading.end();

          if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_SAVE_EQUIP); // '현재 장비 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
        });
        break;

      case 'modify':
        saveExistingEquip({
          apiDomain: _.option.apiDomain,
          searchApiDomain: _.option.searchApiDomain,
          idx: _.data.idx,
          sendData: data,
          beforeSend: () => _.loading.start()

        }).then(function (data, textStatus, jqXHR) {
          console.log('saveExistingEquip - data :', data);

          _.loading.end();

          if (allOf(isObject(data), data.result === 'success')) {
            $(_).trigger({type: EquipSimulator.EVT_SAVE_EQUIP});

          } else {
            _.global.alert(ALERT.FAIL_SAVE_EQUIP); // '현재 장비 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
          }

        }).catch(function (err) {
          console.log('saveExistingEquip - error :', err);

          _.loading.end();

          if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_SAVE_EQUIP); // '현재 장비 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
        });
        break;
    }
  }

  deleteEquipSetting(idx) {
    const _ = this;

    if (truthy(_.loading.isLoading)) return;

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/equip/user/:idx
    deleteSavedEquip({
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      idx: idx,
      beforeSend: () => _.loading.start()

    }).then(function (data, textStatus, jqXHR) {
      console.log('deleteSavedEquip - data :', data);

      _.loading.end();

      if (data.result === 'success') {
        $(_).trigger({type: EquipSimulator.EVT_DELETE_EQUIP_COMPLETE});

      } else {
        if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_DELETE_EQUIP); // '현재 장비 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch(function (err) {
      console.log('deleteSavedEquip - error :', err);

      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_DELETE_EQUIP); // '현재 장비 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  restoreAllEquipsAndTotalStat() { // from TopBar.EVT_RESET
    const _ = this;

    _.equipSetting.restoreAllEquips();
    _.totalStat.restoreAllStats();

    _.equipSetting.resetDiffAtAllEquips();
    _.equipSetting.resetDiffAtTotalPrice();

    _.totalStat.resetDiffAtAllStats();
  }

  destroy() {
    const _ = this;

    if (isDefined(_.topBar)) {
      _.setTopBarEvents(false);

      _.topBar.destroy();
      _.topBar = null;
    }

    if (isDefined(_.equipCharacter)) {
      _.equipCharacter.destroy();
      _.equipCharacter = null;
    }

    if (isDefined(_.equipSetting)) {
      $(_.equipSetting)
        .off(EquipSetting.RESET_ONE_LIST)
        .off(EquipSetting.SHOW_ITEM_SEARCH_LAYER)
        .off(EquipSetting.DISPLAY_AFFECT_STATS);

      _.equipSetting.destroy();
      _.equipSetting = null;
    }

    if (isDefined(_.totalStat)) {
      _.totalStat.destroy();
      _.totalStat = null;
    }

    if (isDefined(_.searchEquipLayer)) {
      $(_.searchEquipLayer)
        .off(SearchEquipLayer.EVT_SELECT_EQUIP)
        .off(SearchEquipLayer.EVT_CLOSE);

      _.searchEquipLayer.destroy();
      _.searchEquipLayer = null;
    }

    // global events
    if (isDefined(_.globalEvents)) {
      _.globalEvents.removeCallback('resize', _.proxy.resizeEventHandler);
    }
  }

  /*
   * by setting qna board
   */
  removeTopBar() {
    const _ = this;

    if (isDefined(_.topBar)) {
      _.setTopBarEvents(false);

      _.topBar.destroy();
      _.topBar = null;
    }

    $('.simulator__equip > header', _.wrap).remove();
  }

  removeTitle() {
    const _ = this;

    if (isDefined(_.equipCharacter)) _.equipCharacter.removeTitleInput();
  }

  unsubscribeScrollEvent() {
    const _ = this;
    if (isDefined(_.equipCharacter)) _.equipCharacter.unsubscribeTotalStatBtnByScrollEvent();
  }

  displayTotalPrice(str = '') {
    const _ = this;
    if (isDefined(_.equipSetting)) _.equipSetting.setEquipTotalPriceStr(str);
  }
}

EquipSimulator.EVT_CLOSE = 'EVT_CLOSE';
EquipSimulator.EVT_SAVE_EQUIP = 'EVT_SAVE_EQUIP';
EquipSimulator.EVT_DELETE_EQUIP_COMPLETE = 'EVT_DELETE_EQUIP_COMPLETE';

export default EquipSimulator;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/EquipSimulator.js